import * as React from 'react';
import { Bar, BarChart as RBarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from 'recharts';

import { ResponsiveContainer } from './ResponsiveContainer';
import { inspectionType } from '../../../constants/generals';

export interface IBarChartProps {
    data: Object[];
    isAnimationActive?: boolean;
    barColors?: string[];
    dataKey: string | string[];
    onClick?(e, i): void;
    customTooltip?: JSX.Element | Function;
}

export class BarChart extends React.PureComponent<IBarChartProps, {}> {

    render() {
        const { data, barColors, dataKey, isAnimationActive, onClick, customTooltip } = this.props;
        const keys = Object.keys(data[0]);
        return (
            <div className="bar-chart" >
                <ResponsiveContainer>
                    <RBarChart data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <XAxis dataKey="name" interval={0} />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3   3" />
                        <Tooltip content={customTooltip} />
                        <Legend />
                        {
                            barColors.map((color, index) => {
                                return <Bar
                                    onClick={(e, i, c) => onClick ? onClick(e, c.target.getAttribute('fill')) : null}
                                    key={index}
                                    label={dataKey[index]}
                                    dataKey={dataKey[index]}
                                    fill={color}
                                />;
                            })
                        }
                    </RBarChart>
                </ResponsiveContainer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ChartComponents/BarChart.tsx